import { render, staticRenderFns } from "./InfoCardMentorings.vue?vue&type=template&id=21985cf4&scoped=true&"
import script from "./InfoCardMentorings.vue?vue&type=script&lang=js&"
export * from "./InfoCardMentorings.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardMentorings.vue?vue&type=style&index=0&id=21985cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21985cf4",
  null
  
)

export default component.exports